<template>
  <div id="hk">
    <div class="uk-position-relative">
      <img src="@/assets/new-lpbanner-2.jpg" width="100%" />

      <div class="uk-position-absolute user_form uk-border-rounded">
        <form id="header_form">
          <h1 class="uk-text-center">Register Now</h1>
          <div class="uk-margin-small">
            <input
              class="uk-input uk-form-width-medium uk-border-pill ukinp"
              type="text"
              placeholder="Name"
              id="header_name"
              name="pr_name"
            />
          </div>

          <div class="uk-margin-small uk-overflow-auto j-center">
            <select class="ib_country_2 uk-input uk-border-pill uk-select" v-model="ccode" name="pr_country">
              <option
                v-for="(code, key) in codes"
                :key="key"
                :value="code"
                class="form-control"
              >{{code + ' (' + key + ')'}}</option>
            </select>

            <input
              class="uk-input uk-border-pill onlydigit pr_mobile ukinp"
              maxlength="15"
              type="Mobile"
              placeholder="Mobile"
              id="header_mobile"
              name="pr_mobile"
            />
          </div>

          <div class="uk-margin-small">
            <div class="fx-relay-email-input-wrapper">
              <input
                class="uk-input uk-form-width-medium uk-border-pill ukinp"
                type="email"
                placeholder="Email"
                id="header_email"
                name="pr_email"
                style="padding-right: 50px;"
              />
              <div class="fx-relay-icon" style="height: 40px; top: 0px; bottom: 0px;">
                <button
                  class="fx-relay-button"
                  id="fx-relay-button"
                  type="button"
                  title="Generate new alias"
                ></button>
              </div>
            </div>
          </div>

          <div class="uk-margin-small">
            <select name="pr_product" id="header_product" class="uk-select uk-border-pill">
              <option>Select Product</option>
              <option
                value="163"
                selected="selected"
              >World's Largest Webinar - How to Start a StartUp</option>
              <option value="86">Become an Independent Business Consultant (IBC)</option>
              <option value="8">Everything About Entrepreneurship (EAE) Program</option>
              <option value="153">Problem Solving Courses (PSC)</option>
              <option value="36">Life Time Membership (LTM)</option>
              <option value="26">WHITE LABELLING Solutions</option>
              <option value="154">Case Studies Project</option>
            </select>
          </div>
          <div class="uk-margin-small">
            <select name="pr_plan_id" id="pr_plan_id" class="uk-select uk-border-pill">
              <option selected="selected">Select Category</option>
              <option value="3">Student</option>
              <option value="2">Professional</option>
              <option value="1">Entrepreneur</option>
            </select>
          </div>
          <div class="uk-margin-small">
            <input
              class="uk-input uk-form-width-medium uk-border-pill ukinp"
              type="text"
              placeholder="Institute/College"
              id="pr_inst_coll"
              name="pr_inst_coll"
            />
          </div>
          <div class="uk-margin-small">
            <select
              class="ib_state uk-input uk-border-pill uk-select"
              id="ib_state_1"
              name="pr_state"
            >
              <option
                class="form-control rounded-0"
                value="0"
                id="inputstate"
                selected="selected"
              >Select State</option>
              <option value="100030">Andaman and Nicobar</option>
              <option value="732">Andhra Pradesh</option>
              <option value="100056">Arunachal Pradesh</option>
              <option value="733">Assam</option>
              <option value="734">Bihar</option>
              <option value="735">Chandigarh</option>
              <option value="736">Chhattisgarh</option>
              <option value="100040">Dadra and Nagar Haveli</option>
              <option value="100039">Daman &amp; diu</option>
              <option value="737">Delhi</option>
              <option value="6180">Goa</option>
              <option value="738">Gujarat</option>
              <option value="739">Haryana</option>
              <option value="100057">Himachal Pradesh</option>
              <option value="740">Jammu and Kashmir</option>
              <option value="741">Jharkhand</option>
              <option value="742">Karnataka</option>
              <option value="743">Kerala</option>
              <option value="100038">Lakshadweep</option>
              <option value="744">Madhya Pradesh</option>
              <option value="745">Maharashtra</option>
              <option value="746">Manipur</option>
              <option value="747">Meghalaya</option>
              <option value="748">Mizoram</option>
              <option value="100058">Nagaland</option>
              <option value="749">Odisha</option>
              <option value="750">Puducherry</option>
              <option value="751">Punjab</option>
              <option value="752">Rajasthan</option>
              <option value="100059">Sikkim</option>
              <option value="753">Tamil Nadu</option>
              <option value="100048">Telangana</option>
              <option value="754">Tripura</option>
              <option value="755">Uttar Pradesh</option>
              <option value="756">Uttarakhand</option>
              <option value="757">West Bengal</option>
            </select>
          </div>

          <div class="form-group">
            <select
              class="form-control curve_corner hidcity uk-input uk-border-pill uk-select"
              id="cs_city"
              name="pr_city"
            >
              <option selected="selected">Select City</option>
            </select>
          </div>

          <div class="uk-margin-small-top">
            <label class="uk-text-small">
              <input class="uk-checkbox checkbox_val" type="checkbox" checked="checked" />&nbsp;&nbsp;Yes, I would like to receive offers, updates
              <br />and marketing materials via email and SMS.
            </label>
          </div>

          <input type="hidden" name="crm_id" id="pp_id_cookie" value="BIMK003866" />
          <input type="hidden" name="pr_date" value="2020-08-07 12:15:52" />
          <input type="hidden" name="event_type" value="dd_form" />
          <input type="hidden" name="referral_url" value="https://f-qr.github.io/bb/" />
          <input type="hidden" class="checkbox_value" name="checkbox_value" />

          <div class="form_submit uk-margin-small-top uk-text-center">
            <button type="button" id="header_form_submit">REGISTER</button>
          </div>
        </form>
      </div>
    </div>

    <div class="uk-container uk-margin-large-top">
      <h2 class="uk-text-center">World's Largest Webinar - How to Start a StartUp</h2>
      <div class="uk-grid uk-grid-match uk-margin-medium-top" uk-grid>
        <div
          class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s uk-width-1-1 uk-first-column"
        >
          <div
            id="changeprone"
            class="uk-background-contain"
            style="background-image: url(https://www.badabusiness.com/dd/site/assets/files/4719/15-aug-wlbs--700x420.jpg)"
          ></div>
        </div>
        <div
          class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s uk-width-1-1 uk-position-relative"
        >
          <div class="info_div">
            <p>
              World’s Largest Webinar For Solopreneurs &amp; Students. Topics to be covered during the Webinar:
              <br />
              <br />How to start a startup?
              <br />How to raise funds?
              <br />How to find TAMs - total addressable Market?
              <br />How to get the first 100 customers?
              <br />How to know the perfect customer?
              <br />How to validate your idea?
              <br />How to build MVP - minimum viable product?
              <br />How find the right problem to solve? Mujhe kya aata hai, mujhe kya bhaata hai, market kya chahta hai?
              <br />Who to raise seed funds?
              <br />How to get selected by a Startup incubator / accelerator?
              <br />How to build the right personality that attracts success?
              <br />How to go from pocket money to professional salary?
              <br />Difference between an employee, intrapreneur and entrepreneur.
              <br />How to influence people and create success?
            </p>
          </div>
          <div class="know_more uk-margin-top">
            <button data-href="#">Register Above</button>
          </div>
        </div>
      </div>
    </div>

    <div class="product_info_bg uk-margin-large-top">
      <div class="uk-container">
        <h2 class="uk-text-center">Become an Independent Business Consultant (IBC)</h2>
        <div class="uk-grid uk-grid-match uk-margin-medium-top" uk-grid>
          <div
            class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s uk-width-1-1 uk-position-relative uk-first-column"
          >
            <div class="info_div">
              <p>Partner with Bada Business by becoming a part-time of full-time business consultant.</p>

              <p>
                <strong>Get an Opportunity to Earn Rs1 – Rs10&nbsp;Lakh per month</strong>
                <strong>&nbsp;that too at a Very</strong>
                <strong>Low Capital Investment</strong>
              </p>

              <p>
                <strong>Support from Bada Business</strong>
              </p>

              <ol>
                <li>ERP&nbsp; and CRM Support</li>
                <li>Mobile App Support</li>
                <li>New Product Trainings</li>
                <li>Support from nearby Regional Channel Partner&nbsp;</li>
                <li>Opportunity to Participate in Brand Events</li>
                <li>Lucrative and Aggressive income slabs</li>
                <li>Opportunity to Meet and interact with Dr Vivek Bindra!</li>
              </ol>
            </div>
            <div class="know_more uk-margin-top">
              <button data-href="https://badabusiness.com/ibc">Know More</button>
            </div>
          </div>
          <div class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s uk-width-1-1">
            <div
              class="uk-background-contain"
              style="background-image: url(https://www.badabusiness.com/dd/site/assets/files/1023/ibc-desktop.jpeg)"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div class="uk-container uk-margin-large-top">
      <h2 class="uk-text-center">Everything About Entrepreneurship (EAE) Program</h2>
      <div class="uk-grid uk-grid-match uk-margin-medium-top" uk-grid>
        <div
          class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s uk-width-1-1 uk-first-column"
        >
          <div
            class="uk-background-contain"
            style="background-image: url(https://www.badabusiness.com/dd/site/assets/files/1020/banner_eae_700x420.jpg)"
          ></div>
        </div>
        <div
          class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s uk-width-1-1 uk-position-relative"
        >
          <div class="info_div">
            <p>
              Everything about Entrepreneurship course
              is the World’s Most Affordable Complete Business Management Program in
              Hindi. This is a 2 years’ App based learning program in which you get:
            </p>

            <ol>
              <li>264 Premium, Exclusive &amp; Publicly Unavailable Videos</li>
              <li>An Opportunity to Learn from Industry Leaders who have Built Billion-Dollar Businesses</li>
              <li>Attend 5 Days Live Session with Dr.Vivek Bindra &amp; Prominent Industry Experts</li>
              <li>
                24 Live Video Q&amp;A Sessions which give you an opportunity to get
                answers from Dr.Vivek Bindra &amp; other Eminent Industry Experts
              </li>
              <li>Award winning content</li>
              <li>Exclusive access to Guiness World Record Making content by Dr. Vivek Bindra</li>
            </ol>
            <p>Our Professors:</p>

            <p>
              Mr. Manu Kumar Jain (C.E.O. – Xiaomi India), Mr. Mohandas Pai
              (Chairman - Manipal Global Education), Mr. Alfred Ford (Global Chairman –
              Ford Motors), Dr. Arvind Lal (Chairman – Lal Pathlabs), Mr. Sanjeev
              Kapoor (Indian Master-chef and co-founder WonderChef) and many – many
              more.
            </p>
          </div>
          <div class="know_more uk-margin-top">
            <button data-href="https://badabusiness.com/">Know More</button>
          </div>
        </div>
      </div>
    </div>

    <div class="product_info_bg uk-margin-large-top">
      <div class="uk-container">
        <h2 class="uk-text-center">Problem Solving Courses (PSC)</h2>
        <div class="uk-grid uk-grid-match uk-margin-medium-top" uk-grid>
          <div
            class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s uk-width-1-1 uk-position-relative uk-first-column"
          >
            <div class="info_div">
              <p>
                Problem Solving Courses are designed to
                give practical solutions &amp; learning to the most important burning
                problems faced by Entrepreneurs. If you are interested in starting your
                own business or want to expand your existing business, but, are facing
                specific challenges, you can buy these courses.
              </p>

              <p>When you buy a PSC course you will receive access to</p>

              <ol>
                <li>Course Videos</li>
                <li>Reading Material</li>
                <li>Massive Action Plan</li>
                <li>Assignments to check your understanding and track your progress</li>
              </ol>
              <p>Available Courses:</p>

              <ol>
                <li>Working Capital Management</li>
                <li>Zero Dollar Marketing</li>
                <li>Busyness to Business</li>
                <li>Enterprise Resource Planning (ERP)</li>
                <li>Finance for Non-Finance</li>
                <li>SPICE: Smart Presentations for Investors, Customers and Employees</li>
                <li>How to Raise Funds</li>
                <li>How To Sell</li>
                <li>How to Start a Start-Up</li>
                <li>How to build a Winning Personality</li>
                <li>Passive Income</li>
              </ol>
              <p>More programs coming soon.</p>
            </div>
            <div class="know_more uk-margin-top">
              <button data-href="https://badabusiness.com/psc">Know More</button>
            </div>
          </div>
          <div class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s uk-width-1-1">
            <div
              class="uk-background-contain"
              style="background-image: url(https://www.badabusiness.com/dd/site/assets/files/1021/banner_psc_14-july-2020-1.jpg)"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div class="uk-container uk-margin-large-top">
      <h2 class="uk-text-center">Life Time Membership (LTM)</h2>
      <div class="uk-grid uk-grid-match uk-margin-medium-top" uk-grid>
        <div
          class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s uk-width-1-1 uk-first-column"
        >
          <div
            class="uk-background-contain"
            style="background-image: url(https://www.badabusiness.com/dd/site/assets/files/1022/ltm_banner_700x420_300r_2.jpg)"
          ></div>
        </div>
        <div
          class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s uk-width-1-1 uk-position-relative"
        >
          <div class="info_div">
            <ol>
              <li>Life Time Membership</li>
              <li>Life Time benefits</li>
              <li>Life Time Business Growth</li>
            </ol>
            <p>When you become a Life-time member of Bada Business you get:</p>

            <ol>
              <li>Lifetime access to EAE Program</li>
              <li>Opportunity to attend 2 EAE Events</li>
              <li>Lifetime access to Aladdin Ka Chirag</li>
            </ol>
            <p>
              <strong>Aladdin Ka Chirag</strong>: A Library of Readymade 600
              Downloadable Templates, Forms, Frameworks, Strategy Sheets, Checklists
              and other tools related to all the departments in a Business – HR,
              Accounting, Legal, Marketing, Finance, Strategy and Product Development
              etc.
            </p>
          </div>
          <div class="know_more uk-margin-top">
            <button data-href="https://badabusiness.com/life-time-membership">Know More</button>
          </div>
        </div>
      </div>
    </div>

    <div class="product_info_bg uk-margin-large-top">
      <div class="uk-container">
        <h2 class="uk-text-center">WHITE LABELLING Solutions</h2>
        <div class="uk-grid uk-grid-match uk-margin-medium-top" uk-grid>
          <div
            class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s uk-width-1-1 uk-position-relative uk-first-column"
          >
            <div class="info_div">
              <p>
                Using the Bada Business Mobile App,
                entrepreneurs and students can learn the practical business solutions
                through Premium Videos, Methodologies, Tools, Frameworks and
                Case-Studies.
              </p>

              <p>
                Our App can be customized as per your learning needs with custom
                learning paths for your leaners. Furthermore, the App can be co-branded
                with your brand logo when you place bulk orders.
              </p>

              <p>
                Who can benefit from our White-Labelling Solutions: Corporate
                Clients, Universities, Colleges, Institutions and Coaching Centres etc.
                <strong>White</strong>-
                <strong>Label Solution</strong>&nbsp;helps you to rebrand and resell our products and content to your own clients.
              </p>

              <p>White-Labelling Benefits:</p>

              <ol>
                <li>
                  <strong>Distinguished Professors</strong>: Through our Bada
                  Business App Dr. Vivek Bindra &amp; our eminent business leaders teach
                  your students award-winning content,. With such an elite line-up of
                  professors you get Competitive Edge over other institutions and attract
                  more students.
                </li>
                <li>
                  <strong>Dual Qualification:</strong> For College Students (Degree
                  from College &amp;&nbsp;Certificate of Completion for EAE Program) adds
                  positive weight to their Resume
                </li>
                <li>
                  <strong>Leverage the Brand name</strong>, Goodwill &amp; recognition of Dr. Vivek Bindra for Brand Promotion on digital properties &amp; outdoor marketing channels
                </li>
                <li>
                  <strong>Dr. Vivek Bindra’s visit*</strong> to Institute for Student
                  Orientation session
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  *(conditions apply)
                </li>
              </ol>
              <p>And many more….</p>
            </div>
            <div class="know_more uk-margin-top">
              <button data-href="https://badabusiness.com/">Know More</button>
            </div>
          </div>
          <div class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s uk-width-1-1">
            <div
              class="uk-background-contain"
              style="background-image: url(https://www.badabusiness.com/dd/site/assets/files/1024/banner_white-lable_14-july-2020-1.jpg)"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div class="uk-container uk-margin-large-top">
      <h2 class="uk-text-center">Case Studies Project</h2>
      <div class="uk-grid uk-grid-match uk-margin-medium-top" uk-grid>
        <div
          class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s uk-width-1-1 uk-first-column"
        >
          <div
            class="uk-background-contain"
            style="background-image: url(https://www.badabusiness.com/dd/site/assets/files/1025/1594896992230_case_study_banner_700x420_300r-1.jpg)"
          ></div>
        </div>
        <div
          class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s uk-width-1-1 uk-position-relative"
        >
          <div class="info_div">
            <p>
              Bada Business is regarded as an authority
              in producing Business Case Studies in an engaging and impressive Video
              format by Dr. Vivek Bindra – Founder &amp; CEO of Bada Business Pvt Ltd.
            </p>

            <p>Our Case studies are based on an in-depth study of your product/service along with competitive analysis.</p>

            <p>
              <strong>USPs of Case Studies by Dr Vivek Bindra</strong>
            </p>

            <ol>
              <li>Case Study in a Story Format</li>
              <li>Strong Call-to-Action</li>
              <li>Reusable for Future Marketing Reach</li>
              <li>Huge Reach: 13+ Million followers on YouTube and 5+Million Followers on Facebook</li>
              <li>Highest Brand Recall</li>
              <li>Engage the right Target Audience</li>
              <li>Qualified Lead Flow</li>
            </ol>
            <p>… and many more</p>
          </div>
          <div class="know_more uk-margin-top">
            <button data-href="https://badabusiness.com/">Know More</button>
          </div>
        </div>
      </div>
    </div>

    <div class="uk-container uk-margin-large-top">
      <h2 class="uk-text-center">Our Eminent Professors</h2>
      <div class="uk-margin-medium-top uk-margin-medium-bottom uk-slider" uk-slider>
        <div class="uk-position-relative">
          <div class="uk-slider-container uk-light">
            <ul
              class="uk-slider-items uk-child-width-1-3@xl uk-child-width-1-3@l uk-child-width-1-3@m uk-child-width-1-3@s uk-child-width-1-1 uk-grid"
              style="transform: translate3d(0px, 0px, 0px);"
            >
              <li tabindex="-1" class="uk-active">
                <img src="@/assets/alfred_ford.jpg" alt width="100%" />
                <div class="img_caption uk-text-center">
                  <div>Mr. Alfred Ford</div>
                  <div>Chairman - Ford Motors</div>
                </div>
              </li>
              <li tabindex="-1" class="uk-active">
                <img src="@/assets/ashish_chauhan.jpg" alt width="100%" />
                <div class="img_caption uk-text-center">
                  <div>Mr. Ashish Chauhan</div>
                  <div>Managing Director &amp; CEO - Bombay Stock Exhange</div>
                </div>
              </li>
              <li tabindex="-1" class="uk-active">
                <img src="@/assets/keki_mistri.jpg" alt width="100%" />
                <div class="img_caption uk-text-center">
                  <div>Mr. Keki Mistry</div>
                  <div>Vice Chairman &amp; CEO - HDFC Ltd.</div>
                </div>
              </li>
              <li tabindex="-1" class>
                <img src="@/assets/kiran_mazumdar_shaw.jpg" alt width="100%" />
                <div class="img_caption uk-text-center">
                  <div>Dr. Kiran Mazumdar Shaw</div>
                  <div>Chairperson - Biocon Ltd</div>
                </div>
              </li>
              <li tabindex="-1">
                <img src="@/assets/manu_jain.jpg" alt width="100%" />
                <div class="img_caption uk-text-center">
                  <div>Mr. Manu Jain</div>
                  <div>Managing Director - Xiaomi India</div>
                </div>
              </li>
              <li tabindex="-1">
                <img src="@/assets/rs_sodhi.jpg" alt width="100%" />
                <div class="img_caption uk-text-center">
                  <div>Mr. R S Sodhi</div>
                  <div>Managing Director - Amul</div>
                </div>
              </li>
            </ul>
          </div>
          <div class="uk-hidden@l uk-light">
            <a
              class="uk-position-center-left uk-position-small uk-icon uk-slidenav-previous uk-slidenav"
              href="#"
              uk-slidenav-previous
              uk-slider-item="previous"
            >
              <svg
                width="14px"
                height="24px"
                viewBox="0 0 14 24"
                xmlns="http://www.w3.org/2000/svg"
                data-svg="slidenav-previous"
              >
                <polyline
                  fill="none"
                  stroke="#000"
                  stroke-width="1.4"
                  points="12.775,1 1.225,12 12.775,23 "
                />
              </svg>
            </a>
            <a
              class="uk-position-center-right uk-position-small uk-icon uk-slidenav-next uk-slidenav"
              href="#"
              uk-slidenav-next
              uk-slider-item="next"
            >
              <svg
                width="14px"
                height="24px"
                viewBox="0 0 14 24"
                xmlns="http://www.w3.org/2000/svg"
                data-svg="slidenav-next"
              >
                <polyline
                  fill="none"
                  stroke="#000"
                  stroke-width="1.4"
                  points="1.225,23 12.775,12 1.225,1 "
                />
              </svg>
            </a>
          </div>
          <div class="uk-visible@l">
            <a
              class="uk-position-center-left-out uk-position-small uk-icon uk-slidenav-previous uk-slidenav"
              href="#"
              uk-slidenav-previous
              uk-slider-item="previous"
            >
              <svg
                width="14px"
                height="24px"
                viewBox="0 0 14 24"
                xmlns="http://www.w3.org/2000/svg"
                data-svg="slidenav-previous"
              >
                <polyline
                  fill="none"
                  stroke="#000"
                  stroke-width="1.4"
                  points="12.775,1 1.225,12 12.775,23 "
                />
              </svg>
            </a>
            <a
              class="uk-position-center-right-out uk-position-small uk-icon uk-slidenav-next uk-slidenav"
              href="#"
              uk-slidenav-next
              uk-slider-item="next"
            >
              <svg
                width="14px"
                height="24px"
                viewBox="0 0 14 24"
                xmlns="http://www.w3.org/2000/svg"
                data-svg="slidenav-next"
              >
                <polyline
                  fill="none"
                  stroke="#000"
                  stroke-width="1.4"
                  points="1.225,23 12.775,12 1.225,1 "
                />
              </svg>
            </a>
          </div>
        </div>
      </div>

      <!-- <div class="uk-margin-large-top uk-text-center">
        <a
          href="https://badabusiness.com/"
          target="_blank"
          class="uk-button uk-button-default uk-border-pill"
        >View All</a>
      </div>-->
    </div>

    <div
      class="footer_reg uk-text-center uk-text-bold uk-margin-large-top"
      href="#header"
      uk-scroll
    >Register Now</div>

    <div class="footer">
      <nav>
        <!-- <div class="uk-container uk-padding-small uk-navbar" uk-navbar>
          <div class="uk-navbar-left">
            <a href="#" class="uk-navbar-item uk-logo uk-padding-remove-left">
              <img src="@/assets/logo-white-new.png" width="170" />
            </a>
          </div>
          <div class="uk-navbar-right">
            <ul class="uk-navbar-nav social_list">
              <li>
                <a class="text-peach" href="https://apple.co/30TwZum">
                  <span class="the-icons span3 icon_wrapper" title>
                    <i class="demo-icon icon-apple"></i>
                  </span>
                </a>
              </li>
              <li>
                <a class="text-peach" href="https://bit.ly/2KbEwPB">
                  <span class="the-icons span3 icon_wrapper" title>
                    <i class="demo-icon icon-android"></i>
                  </span>
                </a>
              </li>

              <li>
                <a class="text-peach" href="https://twitter.com/DrVivekBindra">
                  <span class="the-icons span3 icon_wrapper" title>
                    <i class="demo-icon icon-twitter"></i>
                  </span>
                </a>
              </li>

              <li>
                <a class="text-peach" href="https://www.instagram.com/vivek_bindra/">
                  <span class="the-icons span3 icon_wrapper" title>
                    <i class="demo-icon icon-instagram"></i>
                  </span>
                </a>
              </li>
              <li>
                <a class="text-peach" href="https://www.facebook.com/DailyMotivationByVivekBindra/">
                  <span class="the-icons span3 icon_wrapper" title>
                    <i class="demo-icon icon-facebook"></i>
                  </span>
                </a>
              </li>
              <li>
                <a class="text-peach" href="#">
                  <span class="the-icons span3 icon_wrapper" title>
                    <i class="demo-icon icon-youtube-play"></i>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>-->

        <div class="uk-container uk-padding-small">
          <!-- <hr /> -->
          <div class="uk-navbar-left">
            <a href="#" class="uk-navbar-item uk-logo uk-padding-remove-left">
              <img src="@/assets/logo-white-new.png" width="170" />
            </a>
            <span style="flex-grow: 1;"></span>
            <span class="text-white copyright">(C) 2020 Bada Business. All Rights Reserved.</span>
          </div>
          <!-- <div
            class="uk-text-center text-white copyright"
          >(C) 2020 Bada Business. All Rights Reserved.</div>-->
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { codes } from "../store/contry_codes.js";

export default {
  name: "HelloWorld",
  data() {
    return {
      codes,
      ccode: '+91',
      name: '',
      mobile: '',
      email: '',
      prod: '',
      cat: '',
      clg: '',
      state: '',
    };
  },
  methods: {
    submit(){
      // pr_name=Ronak&pr_country=100&pr_mobile=9834984398&pr_email=ronak1999%40gmail.com&pr_product=163&pr_plan_id=3&pr_inst_coll=Bapu+Collage&pr_state=738&pr_city=3398&crm_id=BIMK003866&pr_date=2020-08-07+12%3A15%3A52&event_type=dd_form&referral_url=https%3A%2F%2Ff-qr.github.io%2Fbb%2F&checkbox_value=1
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#hk {
  background: white;
}
// h3 {
//   margin: 40px 0 0;
// }
// ul {
//   list-style-type: none;
//   padding: 0;
// }
// li {
//   display: inline-block;
//   margin: 0 10px;
// }
// a {
//   color: #42b983;
// }
</style>
